export interface DecodedToken {
    name: string;
    preferred_username: string;
    email: string;
    sub: string;
    resource_access: {
        forms_client: {
            roles: string[];
        },
        kyc_client: {
            roles: string[];
        }
    };
}


export interface UserInfo {
    username: string;
    names: string;
    email: string;
    id: string;
    roles: string[];
    token?: string;
    refreshToken?: string;
}

export const countries: string[] = [
    "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda",
    "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain",
    "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan",
    "Bolivarian Republic of Venezuela", "Bosnia and Herzegovina", "Botswana", "Brazil",
    "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada",
    "Central African Rep", "Chad", "Chile", "Colombia", "Comoros", "Costa Rica", "Croatia",
    "Cuba", "Cyprus", "Czech Republic", "Democratic People's Republic of Korea",
    "Democratic Republic of the Congo", "Democratic Republic of Timor-Leste", "Denmark",
    "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador",
    "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Federated States of Micronesia",
    "Fiji", "Finland", "France", "Gabon", "Georgia", "Germany", "Ghana", "Greece",
    "Greenland", "Grenada", "Guam", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana",
    "Haiti", "Honduras", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq",
    "Israel", "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya",
    "Kingdom of Eswatini", "Kiribati", "Kuwait", "Kyrgyzstan", "Lao People's Democratic Republic",
    "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania",
    "Luxembourg", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta",
    "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Monaco", "Mongolia",
    "Montenegro", "Morocco", "Mount Athos", "Mozambique", "Namibia",
    "Nation of Brunei, Abode of Peace", "Nauru", "Nepal", "Netherlands", "New Zealand",
    "Nicaragua", "Niger", "Nigeria", "Norway", "Oman", "Pakistan", "Palau", "Palestine",
    "Panama", "Papua New Guinea", "Paraguay", "People's Republic of China", "Peru",
    "Philippines", "Plurinational State of Bolivia", "Poland", "Portugal", "Puerto Rico",
    "Qatar", "Republic of Côte d'Ivoire", "Republic of Cabo Verde",
    "Republic of China (Taiwan)", "Republic of Ireland", "Republic of Korea",
    "Republic of Kosovo", "Republic of Moldova", "Republic of North Macedonia",
    "Republic of the Congo", "Republic of the Gambia", "Republic of the Union of Myanmar",
    "Republic of Trinidad and Tobago", "Romania", "Russian Federation", "Rwanda",
    "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome & Principe",
    "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore",
    "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Sudan",
    "Spain", "Sri Lanka", "State of Palestine", "Sudan", "Suriname", "Sweden",
    "Switzerland", "Syria", "Tajikistan", "Thailand", "Togo", "Tonga", "Tunisia", "Turkey",
    "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates",
    "United Kingdom", "United Republic of Tanzania", "United States of America",
    "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City State", "Vietnam", "Yemen",
    "Zambia", "Zimbabwe"
];


export const customerProfessions: string[] = [
    'Student',
    'Employed',
    'Self-Employed',
    'Unemployed',
    'Retired',
    'Homemaker',
    'Entrepreneur',
    'Manager',
    'Consultant',
    'Accountant',
    'Auditor',
    'Human Resources',
    'Recruiter',
    'Marketing Professional',
    'Salesperson',
    'Software Developer',
    'Teacher',
    'Doctor',
    'Nurse',
    'Caregiver',
    'Engineer',
    'Scientist',
    'Lawyer',
    'Police Officer',
    'Military Personnel',
    'Civil Servant',
    'Insurance Agent',
    'Mechanic',
    'Driver',
    'Construction Worker',
    'Waiter/Waitress',
    'Bartender',
    'Farmer',
    'Fitness Trainer',
    'Pastor',
    'Volunteer',
    'Cleaner',
    'Caretaker',
    'Driver',
    'Other',
];
export const districtVillages: any = {
    "Barolong": ["Bethel", "Borobadilepe", "Digawana", "Dinatshana", "Ditlharapa", "Gamajalela", "Gathwane", "Good Hope", "Kgoro", "Dikhukhung", "Kangwe", "Hebron", "Logagane", "Tswagare / Lothoje / Lokalana", "Tswanyaneng", "Metlojane", "Makokwe", "Marojane", "Papatlo", "Phihitshwane", "Molete", "Madingwana", "Sheep Farm", "Motsentshe", "Mogwalale", "Lejwana", "Magoriapitse", "Mogojogojo", "Mmathethe", "Mokgomane", "Pitshane Molopo", "Sedibeng", "Musi", "Tswaaneng", "Leporung", "Mmakgori", "Mabule", "Tshidilamolomo", "Metlobo", "Lorwana", "Malokaganyane", "Sekhutlane"],
    "Central Bobonong": ["Bobonong", "Damochojena", "Kobojango", "Lentswelemoriti", "Lepokole", "Mabolwe", "Mmadinare", "Molalatau", "Motlhabaneng", "Moletemane", "Robelela", "Sefophe", "Semolale", "Mathathane", "Tsetsebjwe", "Tshokwe", "Tobane"],
    "Central Boteti": ["Kedia", "Letlhakane", "Mmatshumo", "Mopipi", "Xhumo", "Tsienyane / Rakops", "Toromoja", "Moreomaoto", "Makalamabedi", "Khwee", "Kumaga", "Motopi", "Mmadikola", "Mokoboxane", "Xere"],
    "Central Mahalapye": ["Bonwapitse", "Dibete Station", "Dovedale", "Chadibe", "Ikongwe", "Mahalapye", "Palla Road / Dinokwe", "Mookane", "Mmaphashalala", "Taupye", "Makwate", "Moshopha", "Machaneng", "Sefhare", "Kudumatse", "Mmutlana", "Mokobeng", "Ngwapa", "Tumasera", "Ramokgonami", "Maape", "Pilikwe", "Mhalapitsa", "Tewane", "Mokgenene", "Shoshong", "Moralane", "Mosolotshane", "Kodibeleng", "Matlhako", "Otse", "Seleka", "Poloka", "Mokoswane"],
    "Central Tutume": ["Borolong", "Chadibe", "Changate", "Dagwi", "Dukwi", "Goshwe", "Gweta", "Jamataka", "Maitengwe", "Nata", "Nkange", "Senete", "Tutume", "Matobo", "Mosetse", "Nswazwi", "Nshakashokwe", "Sebina", "Marobela", "Mathangwane", "Marapong", "Mafongo / Hobona", "Matsitama", "Mokubilo", "Tonota", "Mmeya", "Mandunyane", "Natale", "Shashe / Semotswane", "Shashe - Mooke", "Lepashe", "Semitwe", "Mmanxotae", "Sepako", "Kutamogree", "Mabesekwa", "Makuta", "Makobo", "Tshokatshaa", "Maposa"],

    "Chobe": ["Kachikau", "Lesoma", "Muchinje / Mabele", "Parakarungu", "Pandamatenga", "Satau", "Kasane", "Kavimba", "Kazungula"],

    "Ghanzi": ["Bere", "Charles Hill", "Chobokwane", "Dekar", "East Hanahai", "Ghanzi", "Groote Laagte", "Kacgae", "Karakobis", "Kule", "Makunda", "New Xade", "New Xanagas", "Ncojane", "Qabo", "Tsootsha", "West Hanahai"],

    "Kgalagadi North": ["Hukuntsi", "Hunhukwe", "Inalegolo", "Kang", "Lehututu", "Lokgwabe", "Make", "Monong", "Ncaang", "Ngwatle", "Phuduhudu", "Tshane", "Ukwi", "Zutswa"],

    "Kgalagadi South": ["Bogogobo", "Bokspits", "Bray", "Gachibana", "Khisa", "Khuis", "Khwawa", "Kokotsha", "Kolonkwane", "Makopong", "Maralaleng", "Maubelo", "Middlepits", "Omaweneno", "Tsabong", "Phepheng / Draaihoek", "Rapples Pan", "Struizendam", "Vaalhoek", "Werda", "Maleshe"],

    "Kgatleng": ["Artisia", "Bokaa", "Dikgonnye", "Dikwididi", "Matebeleng", "Oodi", "Modipane", "Mabalane", "Sikwane", "Mmathubudukwane", "Ramonaka", "Malolwane", "Oliphants Drift", "Leshibitse", "Malotwana Siding", "Kgomodiatshaba", "Khurutshe", "Mochudi", "Pilane Station", "Rasesa", "Morwa", "Ramotlabaki"],

    "Kweneng East": ["Boatlaname", "Dikgatlhong", "Ditshukudu", "Gabane", "Gakgatla", "Gakutlo", "Gamodubu", "Hatsalatladi", "Kopong", "Tloaneng", "Kumakwane", "Lephephe", "Lentsweletau", "Mahetlwe", "Kopong", "Molepolole", "Ramaphatle", "Mmankgodi", "Mmopane", "Mogoditshane", "Metsimotlhabe", "Kubung", "Losilakgokong", "Kgope", "Mogonono", "Kweneng", "Leologane", "Mokolodi", "Mmatseta", "Thamaga", "Sojwe", "Shadishadi", "Medie", "Mmanoko"],

    "Kweneng West": ["Botlhapatlou", "Diphuduhudu", "Ditshegwane", "Dutlwe", "Letlhakeng", "Maboane", "Mantshwabisi", "Motokwe", "Ngware", "Salajwe", "Takatokwane", "Tsetseng", "Tswaane", "Monwane", "Malwelwe", "Serinane", "Sesung", "Sorilatholo", "Kotolaname", "Metsibotlhoko", "Kaudwane", "Maratshwane", "Khudumelapye", "Moshaweng"],

    "Ngamiland Delta": ["Daonara", "Ditshiping", "Jao", "Katamaga", "Morutsha", "Xaxaba"],

    "Ngamiland East": ["Bodibeng", "Botlhatlogo", "Chanoga", "Habu", "Kgakge / Makakung", "Kareng", "Komana", "Makalamabedi", "Mababe", "Matlapana", "Matsaudi / Sakapane", "Maun", "Phuduhudu", "Sankuyo", "Sehithwa", "Shorobe", "Toteng", "Tsao", "Semboyo"],

    "Ngamiland West": ["Beetsha", "Chukumuchu", "Eretsha", "Etsha 1", "Etsha 13", "Etsha 6", "Gani", "Gonutsuga", "Gudingwa", "Gumare", "Ikoga", "Kajaja", "Kaux whi", "Mohembo East", "Mohembo West", "Mokgacha", "Ngarange", "Nxamasere", "Nxaunxau", "Nokaneng", "Sepopa", "Shakawe", "Seronga", "Samochema", "Sekondomboro", "Tobere", "Tubu", "Xakao", "Хаха", "Xhauga", "Mogomotho", "Qangwa"],

    "Ngwaketse": ["Betesankwe", "Diabo", "Dipotsana", "Lefoko", "Lekgolobotlo", "Lotlhakane", "Lotlhakane West", "Ranaka", "Pitseng", "Mokhomba", "Lekgolobotlo", "Seherelela", "Sese", "Sesung", "Segwagwa", "Magotlhwane", "Manyana", "Maokane", "Kgomokasitwa", "Molapowabojang", "Ralekgetho", "Moshaneng", "Moshupa", "Ntlhantlhe", "Tshwaane", "Semane", "Lotlhakane", "Tlhankane", "Selokolela", "Mogonye", "Gasita", "Tsonyane"],

    "Ngwaketse West": ["Itholoke", "Kanaku", "Keng", "Khakhea", "Khonkhwa", "Kokong", "Kutuku", "Mabutsane", "Mahotshwane", "Morwamosu", "Sekoma"],

    "North East": ["Botalaote", "Butale", "Ditladi", "Gambule", "Gulubane", "Gungwe", "Jackalas 1", "Jackalas No 2", "Kalakamati", "Kgari", "Letsholathebe", "Makaleng", "Mambo", "Mapoka", "Masingwaneng", "Masukwane", "Masunga", "Matenge", "Matshelagabedi", "Matsiloje", "Matopi", "Mbalambi", "Moroka", "Mosojane", "Mulambakwena", "Nlakhwane", "Ramokgwebana", "Sechele", "Sekakangwe", "Senyawe", "Siviya", "Tati Siding", "Themashanga", "Tsamaya", "Tshesebe", "Toteng", "Vukwi", "Mabudzane", "Mowana", "Patayamatebele", "Pole", "Zwenshambe"],
    "Serowe Palapye": ["Diloro", "Dimajwe", "Gamabuo", "Gojwane", "Goo - Sekgweng", "Gootau", "Kgagodi", "Lecheng", "Lerala", "Lesenepole / Matolwane", "Maunatlala", "Mabeleapudi", "Mmashoro", "Majwanaadipitse", "Majwaneng", "Moeng", "Mogapi", "Mogapinyana", "Mogome", "Moiyabana", "Mokgware", "Mokokwana", "Seolwane", "Malaka", "Malatswai", "Mokhungwana", "Manaledi", "Palapye", "Paje", "Serowe", "Serule", "Mogorosi", "Thabala", "Moiyabana", "Radisele", "Topisi", "Paje", "Matlhakola", "Tshimoyapula", "Mmashoro", "Thabala", "Ratholo", "Moremi", "Moreomabele", "Sehunou", "Motshegaletau", "Tamasane", "Mosweu", "Mokokwana"],
    "South East": ["Mogobane", "Ramotswa", "Ramotswa station / Taung", "Tlokweng", "Otse"],
    "Gaborone": ["Block 3", "Block 4", "Block 5", "Block 6", "Block 7", "Block 8", "Block 9", "Block 10"],
    "Francistown": ["New Stance", "Tuli block", "Block 5", "Block 6", "Block 7", "Block 8", "Block 9", "Block 10"]
};